import { render, staticRenderFns } from "./FiltroDataCriacao.vue?vue&type=template&id=b7d3aae0&"
import script from "./FiltroDataCriacao.vue?vue&type=script&lang=js&"
export * from "./FiltroDataCriacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports